import { Guid, RecursivePartial } from '@models/base';
import { VzTip } from './tip';

export enum VzSystemWarningSeverity {
    Info        = 0,
    Warning     = 1,
    Critical    = 2,
}
export class VzSystemWarning extends VzTip {
    severity: VzSystemWarningSeverity = VzSystemWarningSeverity.Info;
    orgId?: Guid;
    personId?: Guid;

    constructor(json?: RecursivePartial<VzSystemWarning>) {
        super(json);
        this.parseVzSystemWarning(json || {});
    }

    parse(json: RecursivePartial<VzSystemWarning>): VzSystemWarning {
        super.parse(json);
        this.parseVzSystemWarning(json);
        return this;
    }

    private parseVzSystemWarning(json: RecursivePartial<VzSystemWarning>): void {
        VzSystemWarning.assignFields<VzSystemWarning>(this, json, ['severity', 'orgId', 'personId']);
    }
}
